













import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { TextStyle, Alignments } from "../../../domain/drawing";
import { RectangleAreaDrawableMixin } from "./mixins";

@Component({
})
export default class InputEditor extends Mixins(ModelEditableMixin, RectangleAreaDrawableMixin) {
  @Prop({ default: false })
  readonly: boolean;

  @Prop()
  textStyle: TextStyle;

  get widthStyle() {
    return { width: this.rectangle.width + "px" };
  }

  get textStyles() {
    return {
      color: this.textStyle.color.value,
      fontFamily: this.textStyle.fontFamily,
      fontSize: this.textStyle.baseFontSize + "px",
      textAlign: this.textAlign(),
      alignSelf: this.alignSelf()
    };
  }

  private textAlign(): string {
    return (this.textStyle.textAlign & Alignments.Left) === Alignments.Left
      ? "left"
      : (this.textStyle.textAlign & Alignments.Center) === Alignments.Center
        ? "center"
        : (this.textStyle.textAlign & Alignments.Right) === Alignments.Right
          ? "right"
          : "";
  }

  private alignSelf(): string {
    return (this.textStyle.textAlign & Alignments.Top) === Alignments.Top
      ? "flex-start"
      : (this.textStyle.textAlign & Alignments.Middle) === Alignments.Middle
        ? "center"
        : (this.textStyle.textAlign & Alignments.Bottom) === Alignments.Bottom
          ? "flex-end"
          : "";
  }
}
